export function removeInvisibleChars(str: string) {
  return str.replace(
    // eslint-disable-next-line no-control-regex
    /[\u200A-\u200F\u202A-\u202F\u2028\u2029\uFEFF\u0000-\u001F]/g,
    "",
  );
}
